import { CommercialDocumentProcessType } from '@app/pages/commercial-documents/components/commercial-document-list/enums/commercial-document-list.enum';

enum ProcessTypeIdFromDirectoriesCatalog {
  Agreement = '2d952f27-0d62-464f-f693-08dced269bc7',
  Order = '8fe4d5db-0a81-4948-f694-08dced269bc7',
  Receipt = '3afe1950-d4fc-4938-f695-08dced269bc7'
}

export const setNeededProcessType = (
  commercialDocumentProcessType: CommercialDocumentProcessType
): ProcessTypeIdFromDirectoriesCatalog => {
  switch (commercialDocumentProcessType) {
    case CommercialDocumentProcessType.Agreement:
      return ProcessTypeIdFromDirectoriesCatalog.Agreement;
    case CommercialDocumentProcessType.Order:
      return ProcessTypeIdFromDirectoriesCatalog.Order;
    case CommercialDocumentProcessType.Receipt:
      return ProcessTypeIdFromDirectoriesCatalog.Receipt;
  }
};
